import baseAPI from '@/api/base';
import {
  EditEmployeeOvertime,
  ExportOvertime,
  GetEmployeeOvertime,
  GetOvertimeAnalytics,
  RegisterEmployeeOvertime,
  UpdateOvertimeStatus,
} from '@/dtos/employee_overtime.dto';
import {
  DELETE_EMPLOYEE_OVERTIME_URL,
  EDIT_EMPLOYEE_OVERTIME_URL,
  EXPORT_OVERTIME_URL,
  GET_EMPLOYEE_OVERTIMES_BY_EMPLOYEE_URL,
  GET_EMPLOYEE_OVERTIME_URL,
  GET_OVERTIME_ANALYTICS_URL,
  GET_OVERTIME_MONTH_GRID_URL,
  REGISTER_EMPLOYEE_OVERTIME_URL,
  TOGGLE_EMPLOYEE_OVERTIME_IS_ACTIVE_URL,
  UPDATE_OVERTIME_STATUS_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeOvertime {
  static getEmployeeOvertimes = async (params: GetEmployeeOvertime): Promise<AxiosResponse> =>
    baseAPI.get(GET_EMPLOYEE_OVERTIME_URL, { params });

  static getEmployeeOvertimesByEmployee = async (params: GetEmployeeOvertime): Promise<AxiosResponse> =>
    baseAPI.get(GET_EMPLOYEE_OVERTIMES_BY_EMPLOYEE_URL, { params });

  static getOvertimeAnalytics = async (params: GetOvertimeAnalytics): Promise<AxiosResponse> =>
    baseAPI.get(GET_OVERTIME_ANALYTICS_URL, { params });

  /** entries + holiday day keys + payroll lock for one employee/type/month */
  static getOvertimeMonthGrid = async (params: {
    organizationId?: string; employeeId: string; overtimeSettingId: string; month: number; year: number;
  }): Promise<AxiosResponse> => baseAPI.get(GET_OVERTIME_MONTH_GRID_URL, { params });

  static exportOvertime = async (params: ExportOvertime): Promise<AxiosResponse> =>
    baseAPI.get(EXPORT_OVERTIME_URL, { params, responseType: 'blob' });

  static registerEmployeeOvertime = async (payload: RegisterEmployeeOvertime): Promise<AxiosResponse> =>
    baseAPI.post(REGISTER_EMPLOYEE_OVERTIME_URL, { ...payload });

  static editEmployeeOvertime = async (payload: EditEmployeeOvertime): Promise<AxiosResponse> =>
    baseAPI.put(EDIT_EMPLOYEE_OVERTIME_URL, { ...payload });

  static updateOvertimeStatus = async (payload: UpdateOvertimeStatus): Promise<AxiosResponse> =>
    baseAPI.patch(UPDATE_OVERTIME_STATUS_URL, { ...payload });

  static toggleEmployeeOvertimeIsActive = async (payload: { id: string }): Promise<AxiosResponse> =>
    baseAPI.patch(TOGGLE_EMPLOYEE_OVERTIME_IS_ACTIVE_URL, { ...payload });

  static deleteEmployeeOvertime = async (id: string): Promise<AxiosResponse> =>
    baseAPI.delete(`${DELETE_EMPLOYEE_OVERTIME_URL}/${id}`);
}

export default EmployeeOvertime;
